import store from "src/store"
import { addMessage } from "src/store/messages"
import { playUiSound } from "src/utils/audio"

export const logMessage = ({ text, type }) => {
  /* Every toast in the app comes through here, so a refusal gets its sound in one place rather
     than at each of the screens that raise one. Only the refusals: a success toast that chimed
     would be a reward for something the player already knows worked, and the shop raises three of
     them in a row. */
  if (type === "error") playUiSound("error")
  return store.dispatch(
    addMessage({
      text: text,
      type: type,
    })
  )
}
